import { TimePicker } from "@mui/x-date-pickers";
import BaseCadastro from "components/BaseCadastro";
import dayjs from "dayjs";
import ContaParametro from "model/administracao/cadastro/ContaParametro";
import Parametro from "model/administracao/cadastro/Parametro";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { useEffect, useState } from "react";
import ContaParametroService from "service/administracao/cadastro/ContaParametroService";


const contaParametroService = new ContaParametroService();

export default function ContaParametroCadastro() {

    const [contaParametro, setContaParametro] = useState<ContaParametro>(new ContaParametro());
    const [parametrosDisponiveis, setParametrosDisponiveis] = useState<Parametro[]>([]);
    const [editando, setEditando] = useState<boolean>(false);


    useEffect(() => {
        if (window.location.pathname !== ('/parametro/cadastrar')) {
            setEditando(true);
        }
        contaParametroService.getParametrosDisponiveis().then((data) => {
            setParametrosDisponiveis(data);
        }).catch((err) => {
            console.error(err);
        });
    }, [])

    function validar() {
        return true;
    }

    const campoValor = () => {
        if (contaParametro.parametro.tipo === 'TEXTO') {
            return <InputText
                value={contaParametro.valorTexto}
                onChange={(e) => setContaParametro({ ...contaParametro, valorTexto: e.target.value, valorInteiro: 0, valorNumerico: 0 })}
                style={{ width: '61%' }}
            />;
        }
        if (contaParametro.parametro.tipo === "NUMERICO") {
            return <InputNumber
                value={contaParametro.valorNumerico}
                locale="pt-BR"
                maxFractionDigits={3}
                onChange={(e) => setContaParametro({ ...contaParametro, valorNumerico: e.value, valorInteiro: 0, valorTexto: "" })}
                style={{ width: '61%' }}
            />;
        }
        if (contaParametro.parametro.tipo === "INTEIRO") {
            return <InputNumber
                value={contaParametro.valorInteiro}
                onChange={(e) => setContaParametro({ ...contaParametro, valorInteiro: e.value, valorNumerico: 0, valorTexto: "" })}
                style={{ width: '61%' }}
            />;
        }
        if (contaParametro.parametro.tipo === "HORARIO") {
            return <div style={{ width: '61%' }}>
                <TimePicker
                    value={dayjs().hour(0).minute(contaParametro.valorHorario ?? 0)}
                    onChange={(newValue) => setContaParametro({ ...contaParametro, valorHorario: newValue ? ((newValue.hour() * 60) + newValue.minute()) : 0 })}
                />;
            </div>
        }
        if (contaParametro.parametro.tipo === "BOOLEANO") {
            return <Dropdown
                value={contaParametro.valorBooleano}
                options={[{ label: "Sim", value: true }, { label: "Não", value: false }]}
                onChange={(e) => setContaParametro({ ...contaParametro, valorBooleano: e.target.value })}
                style={{ width: '61%' }}
            />;
        }
        return <InputText disabled style={{ width: '61%' }} />;
    }

    return (

        <BaseCadastro model={contaParametro} service={contaParametroService} setModel={(value: ContaParametro) => setContaParametro(value)} validar={() => validar()} urlService="/parametro" pathCadastro="/parametro" tituloPagina={'Pârametro'}>

            <div className="row">
                <label className="col col-sm-12">Parâmetro</label>
                <div className="col-sm-12">
                    {editando ?
                        <InputText value={contaParametro.parametro.sigla} disabled style={{ width: '30%', marginRight: '1%' }} />
                        : <Dropdown filter
                            value={contaParametro.parametro}
                            options={parametrosDisponiveis} optionLabel="sigla"
                            onChange={(e) => setContaParametro({ ...contaParametro, parametro: e.target.value })}
                            style={{ width: '30%', marginRight: '1%' }}
                        />}
                    <InputText value={contaParametro.parametro.nome ? contaParametro.parametro.nome : ""} disabled style={{ width: '30%' }} />
                </div>
            </div>

            <div className="row">
                <label className="col col-sm-12">Descrição</label>
                <div className="col-sm-12">
                    <InputTextarea
                        value={contaParametro.parametro.descricao}
                        disabled
                        rows={2}
                        style={{ width: '61%' }}
                    />
                </div>
            </div>

            <div className="row">
                <label className="col col-sm-12">Valor</label>
                <div className="col-sm-12">
                    {campoValor()}
                </div>
            </div>

        </BaseCadastro>
    );

}